/** Display size in portal header (matches `.portal-header-logo` height). */
export const PORTAL_LOGO_DISPLAY_PX = 80;

/** Exported asset size (2× display for crisp rendering). */
export const PORTAL_LOGO_EXPORT_PX = 160;

export const PORTAL_LOGO_MAX_UPLOAD_BYTES = 2 * 1024 * 1024;

export const PORTAL_LOGO_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif';

export const PORTAL_LOGO_STORAGE_NAME = 'logo.png';

export const PORTAL_LOGO_SHAPE = {
  circle: 'circle',
  square: 'square',
};

/** Default mask shown in header (grey placeholder is always circular). */
export const PORTAL_LOGO_DEFAULT_SHAPE = PORTAL_LOGO_SHAPE.circle;
